import React from "react";
import SettingsRoute from "../SettingsRoute/SettingsRoute";
const SettingsHome = () => {
  return <SettingsRoute></SettingsRoute>;
};

export default SettingsHome;
